<div *ngIf="accounts.length > 0">
  <table class="table table-striped tr-table table-bottom-spacer">
    <thead>
    <tr>
      <th>Account</th>
      <th>Role</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let account of accounts">
      <td class="font-weight-bold" [innerText]="account.accountName"></td>
      <td [innerText]="account.role | titlecase"></td>
      <td>
        <div class="d-flex flex-row justify-content-center" *ngIf="account.inviteId">
          <button class="btn btn-info mr-2" (click)="acceptInvite(account.inviteId)">Accept</button>
          <button class="btn btn-danger" (click)="declineInvite(account.inviteId)">Decline</button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
